import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitStatus, setSubmitStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitStatus("submitting");

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get("website_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setSubmitStatus("success");
      setStatusMsg("订阅成功！感谢您的关注。");
      setEmail("");
      return;
    }

    try {
      const res = await fetch("http://xv8g8.cn/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email: formData.get("email") as string }).toString(),
      });
      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === "OK") {
        setSubmitStatus("success");
        setStatusMsg("订阅成功！感谢您的关注。");
        setEmail("");
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || "订阅失败，请稍后再试。";
        setSubmitStatus("error");
        setStatusMsg(errMsg);
      }
    } catch {
      setSubmitStatus("error");
      setStatusMsg("网络错误，请检查连接后重试。");
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-2/5">
            <h2 className="text-2xl font-bold mb-6" style={{ fontFamily: "var(--font-heading)" }}>韩漫屋</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-sm">
              韩漫屋致力于为广大读者提供海量免费正版韩国漫画，涵盖恋爱、校园、奇幻等多种题材。每日更新，品质保证，让阅读成为一种享受。
            </p>
            <form onSubmit={handleSubscribe} className="max-w-sm">
              <label className="text-xs text-foreground-500 mb-2 block">订阅我们的更新通知</label>
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱地址"
                  required
                  className="flex-1 px-4 py-2.5 text-sm border-b-2 border-background-300 bg-transparent focus:border-primary-500 outline-none transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitStatus === "submitting"}
                  className="px-6 py-2.5 text-sm font-medium rounded-full border-2 border-foreground-300 text-foreground-700 hover:border-foreground-500 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {submitStatus === "submitting" ? "提交中..." : "订阅"}
                </button>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="absolute opacity-0 pointer-events-none w-0 h-0"
                style={{ position: 'absolute', left: '-9999px' }}
              />
              {submitStatus !== "idle" && (
                <p className={`text-xs mt-2 ${submitStatus === "success" ? "text-emerald-600" : "text-red-500"}`}>
                  {statusMsg}
                </p>
              )}
            </form>
          </div>

          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">快速入口</h3>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">热门分类</Link>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">关于我们</Link>
              </div>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h3>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">{cat.name}</Link>
                ))}
              </div>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">帮助中心</h3>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">关于我们</Link>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">常见问题</a>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">联系我们</a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 韩漫屋 - 版权所有</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}